var global = require('../internals/global');
var setGlobal = require('../internals/set-global');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/shared-store.js
// module id = 356
// module chunks = 1